/** @format */

import React, { useEffect, useState } from "react";
import OrdersContentColumn from "../content/OrdersContentColumn";
import SectionItem from "../../orders-new/section-item";
import OrdersSectionItemInfoColumn from "../../orders-new/section-item/components/OrdersSectionItemInfoColumn";
import OrdersDatePicker from "../date-picker-new";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import AddYourCity from "../add-your-city/AddYourCity";
import CustomSelect from "../../custom/custom-select";
import OrdersMap from "../../orders-new/map/OrdersMap";
import OrdersSectionItemCreate from "../../orders-new/section-item/components/OrdersSectionItemCreate";
import CopyIcon from "../../shared/icons/CopyIcon";
import OrdersLocationInfo from "../../orders-aviation/location-info/OrdersLocationInfo";
import { t } from "i18next";
import { useScreenSize } from "../../../hooks/useScreenSize";
import { useAirOrderLimit } from "../../../hooks/useClientLimits";
import AccessDeniedModal from "../../shared/SubscriptionModal/AccessDeniedModal";

import AviationOrderDetails from "../../orders-aviation/components/AviationOrderDetails";
import UnifiedCarrierSelection from "../unified-create/UnifiedCarrierSelection";
import { validateAviationOrder } from "../../../pages/orders/utils/aviationOrderPayload";
import creationStyles from "../unified-create/UnifiedOrderCreation.module.scss";

const OrdersCreateAviationView = (props) => {
  const {
    setCountryFrom,
    setCityFrom,
    countries,
    countryFrom,
    citiesFrom,
    cityFrom,
    countryTo,
    setCountryTo,
    setCityTo,
    citiesTo,
    cityTo,
    pickUpDate,
    pickUpStartTime,
    pickUpEndTime,
    minPickDate,
    setPickUpDate,
    setPickUpStartTime,
    setPickUpEndTime,
    deliveryDate,
    deliveryStartTime,
    deliveryEndTime,
    setDeliveryDate,
    setDeliveryStartTime,
    setDeliveryEndTime,
    addressTo,
    setAddressTo,
    recipientUpdate,
    addressFrom,
    setAddressFrom,
    setRecipientUpdate,
    recipientName,
    setRecipientName,
    recipientPhone,
    setRecipientPhone,
    createLoading,
    createOrder,
    setIsСallСities,
    isLoadingMap,
    routeData,
    routeStartCity,
    setCoordinatesFrom,
    setCoordinatesTo,
    coordinatesFrom,
    coordinatesTo,
    addressIdFrom,
    addressIdTo,
    setAddressIdFrom,
    setAddressIdTo,
    points,
    senderName,
    setSenderName,
    setSenderPhone,
    setRouteDistance,
    setRouteDuration,
    isCopy = false,
    isEdit = false,
    headTitle = "",
    airportFrom,
    airportTo,
    setAirportFrom,
    setAirportTo,
  } = props;
  const { user } = useSelector((state) => state);
  const { isMobileView } = useScreenSize();
  const { airOrderLimit } = useAirOrderLimit();

  const [isOpenAddFrom, setIsOpenAddFrom] = useState(false);
  const [isOpenAddTo, setIsOpenAddTo] = useState(false);
  const [initialCityNameFrom, setInitialCityNameFrom] = useState("");
  const [initialCityNameTo, setInitialCityNameTo] = useState("");
  const [isDisplayModal, changeDisplayModal] = useState(false);
  const [errors, setErrors] = useState({});

  const handleCountryFromChange = (country) => {
    if (country?.id === countryFrom?.id) return;
    setCountryFrom(country);
    setCityFrom(null);
    setAddressFrom(null);
    setAddressIdFrom(null);
    setCoordinatesFrom(null);
    setAirportFrom(null);
  };

  const handleCountryToChange = (country) => {
    if (country?.id === countryTo?.id) return;
    setCountryTo(country);
    setCityTo(null);
    setAddressTo(null);
    setAddressIdTo(null);
    setCoordinatesTo(null);
    setAirportTo(null);
  };

  const submitFormData = () => {
    if (createLoading) return;
    if (
      user &&
      (!user.permissions?.includes("order_create") ||
        (!isEdit && !user.role?.isUnlimited && airOrderLimit !== null && airOrderLimit <= 0))
    ) {
      changeDisplayModal(true);
      return;
    }
    const permission = props.assignmentMethod === "DirectAssignment" ? "expeditor_view" : "tender_view";
    if (!user?.permissions?.includes(permission)) {
      toast.info(t("common.noAccessSupportMessage"));
      return;
    }
    const validationErrors = validateAviationOrder(props, t);
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length) {
      toast.error(t("unifiedOrder.checkFields"));
      return;
    }
    createOrder();
  };

  useEffect(() => {
    if (
      (user && user?.permissions?.includes("restricted_view")) ||
      (user && user?.permissions && !user?.permissions?.includes("order_create"))
    ) {
      changeDisplayModal(true);
    } else if (
      !isEdit &&
      user &&
      user?.role &&
      !user?.role?.isUnlimited &&
      airOrderLimit !== null &&
      airOrderLimit <= 0
    ) {
      changeDisplayModal(true);
    }
  }, [user, airOrderLimit, isEdit]);

  return (
    <div style={{ position: "relative" }}>
      {/* Info */}
      <OrdersContentColumn position className={creationStyles.layout}>
        {(isCopy || isEdit) && (
          <SectionItem
            column={2}
            title={headTitle}
            isShadow
            isCopy
            prefixStart={<CopyIcon fill="#6D7885" />}
            isCunter={false}
          ></SectionItem>
        )}

        <SectionItem column={2} title={t("ordersCreateDesktop.fromSection.title")} counter={1} isShadow>
          <OrdersSectionItemInfoColumn contentGridColumn={"1fr 1fr"}>
            <OrdersSectionItemInfoColumn title={t("ordersCreateDesktop.fromSection.countryLabel")}>
              <CustomSelect
                key={"countries-from"}
                labelText={t("ordersCreateDesktop.fromSection.countryShortLabel") + "*"}
                placeholder={t("ordersCreateDesktop.fromSection.countryLabel")}
                errorText={!countryFrom && errors?.countryFrom}
                options={countries}
                defaultValue={countryFrom}
                returnObject
                onSubmit={handleCountryFromChange}
              />
            </OrdersSectionItemInfoColumn>
            <OrdersSectionItemInfoColumn>
              <CustomSelect
                labelText={t("ordersCreateDesktop.fromSection.cityShortLabel") + "*"}
                placeholder={t("ordersCreateDesktop.fromSection.cityLabel")}
                errorText={!cityFrom && errors?.cityFrom}
                options={citiesFrom}
                defaultValue={cityFrom}
                returnObject
                isDisabled={!countryFrom}
                onSubmit={(item) => {
                  setCityFrom(item);
                  setAddressFrom(null);
                  setAddressIdFrom(null);
                }}
                showNoOptionsMessage={true}
                onNoOptionsClick={(searchValue) => {
                  setInitialCityNameFrom(searchValue);
                  setIsOpenAddFrom(true);
                }}
              />
              {isOpenAddFrom && (
                <AddYourCity
                  setCountry={handleCountryFromChange}
                  setCity={setCityFrom}
                  countries={countries}
                  country={countryFrom}
                  setIsСallСities={setIsСallСities}
                  setAddedCityId={setCityFrom}
                  isOpenAdd={isOpenAddFrom}
                  setIsOpenAdd={setIsOpenAddFrom}
                  initialCityName={initialCityNameFrom}
                />
              )}
            </OrdersSectionItemInfoColumn>
          </OrdersSectionItemInfoColumn>

          <OrdersSectionItemInfoColumn contentGridColumn={isMobileView ? "1fr" : "1fr 1.3fr"}>
            <OrdersDatePicker
              date={pickUpDate}
              timeStart={pickUpStartTime}
              timeEnd={pickUpEndTime}
              minDate={minPickDate}
              isSender
              isEditable
              setDate={setPickUpDate}
              setTimeStart={setPickUpStartTime}
              setTimeEnd={setPickUpEndTime}
              labelText={t("ordersCreateDesktop.fromSection.dateLabel")}
              labelTimeStart={t("ordersCreateDesktop.fromSection.timeStartLabel")}
              labelTimeEnd={t("ordersCreateDesktop.fromSection.timeEndLabel")}
              placeholderText={t("ordersCreateDesktop.fromSection.datePlaceholder")}
              errorDate={!pickUpDate && errors?.pickUpDate}
              errorTimeStart={!pickUpStartTime && errors?.pickUpStartTime}
              errortimeEnd={!pickUpEndTime && errors?.pickUpEndTime}
            />
          </OrdersSectionItemInfoColumn>

          <OrdersSectionItemInfoColumn>
            <OrdersLocationInfo
              labelText={t("ordersCreateDesktop.fromSection.senderLabel") + "*"}
              errorText={(!addressFrom && errors?.addressFrom) || (!senderName && errors?.senderName)}
              isSender
              isEditable
              forceOpenDropdown={!!addressTo}
              forceOpenDropdownCount={recipientUpdate}
              companyName={senderName}
              countries={countries}
              countrySelected={countryFrom}
              citySelected={cityFrom}
              address={addressFrom}
              onCoordinates={setCoordinatesFrom}
              onRecipientPhone={setSenderPhone}
              onAddressId={setAddressIdFrom}
              onChangeResipient={setSenderName}
              onChangeAddress={(item) => {
                setAddressFrom(item);
                setRecipientUpdate((prev) => prev + 1);
              }}
              onChangeCountry={handleCountryFromChange}
              onChangeCity={(city) => {
                setCityFrom(city);
              }}
            />
          </OrdersSectionItemInfoColumn>
        </SectionItem>

        <SectionItem
          column={2}
          title={t("ordersCreateDesktop.toSection.title")}
          counter={2 + points.length}
          isShadow
        >
          <OrdersSectionItemInfoColumn contentGridColumn={"1fr 1fr"}>
            <OrdersSectionItemInfoColumn title={t("ordersCreateDesktop.toSection.title")}>
              <CustomSelect
                labelText={t("ordersCreateDesktop.fromSection.countryShortLabel") + "*"}
                placeholder={t("ordersCreateDesktop.toSection.title")}
                options={countries}
                errorText={!countryTo && errors?.countryTo}
                defaultValue={countryTo}
                returnObject
                onSubmit={handleCountryToChange}
              />
            </OrdersSectionItemInfoColumn>
            <OrdersSectionItemInfoColumn>
              <CustomSelect
                labelText={t("ordersCreateDesktop.fromSection.cityShortLabel") + "*"}
                placeholder={t("ordersCreateDesktop.toSection.cityLabel")}
                errorText={!cityTo && errors?.cityTo}
                options={citiesTo}
                defaultValue={cityTo}
                returnObject
                isDisabled={!countryTo}
                onSubmit={(item) => {
                  setCityTo(item);
                  setAddressTo(null);
                  setCoordinatesTo(null);
                }}
                showNoOptionsMessage={true}
                onNoOptionsClick={(searchValue) => {
                  setInitialCityNameTo(searchValue);
                  setIsOpenAddTo(true);
                }}
              />
              {isOpenAddTo && (
                <AddYourCity
                  setCountry={handleCountryToChange}
                  setCity={setCityTo}
                  country={countryTo}
                  countries={countries}
                  setIsСallСities={setIsСallСities}
                  setAddedCityId={setCityTo}
                  isOpenAdd={isOpenAddTo}
                  setIsOpenAdd={setIsOpenAddTo}
                  initialCityName={initialCityNameTo}
                />
              )}
            </OrdersSectionItemInfoColumn>
          </OrdersSectionItemInfoColumn>

          <OrdersSectionItemInfoColumn contentGridColumn={isMobileView ? "1fr" : "1fr 1.3fr"}>
            <OrdersDatePicker
              date={deliveryDate}
              timeStart={deliveryStartTime}
              timeEnd={deliveryEndTime}
              minDate={pickUpDate}
              isEditable
              setDate={setDeliveryDate}
              setTimeStart={setDeliveryStartTime}
              setTimeEnd={setDeliveryEndTime}
              labelText={t("ordersCreateDesktop.toSection.dateLabel")}
              labelTimeStart={t("ordersCreateDesktop.fromSection.timeStartLabel")}
              labelTimeEnd={t("ordersCreateDesktop.fromSection.timeEndLabel")}
              placeholderText={t("ordersCreateDesktop.fromSection.datePlaceholder")}
              errorDate={!deliveryDate && errors?.deliveryDate}
              errorTimeStart={!deliveryStartTime && errors?.deliveryStartTime}
              errortimeEnd={!deliveryEndTime && errors?.deliveryEndTime}
            />
          </OrdersSectionItemInfoColumn>

          <OrdersSectionItemInfoColumn>
            <OrdersLocationInfo
              labelText={t("ordersCreateDesktop.toSection.recipientLabel") + "*"}
              errorText={(!recipientName && errors?.recipientName) || (!addressTo && errors?.addressTo)}
              isEditable
              forceOpenDropdown={!!addressFrom}
              forceOpenDropdownCount={recipientUpdate}
              countries={countries}
              address={addressTo}
              countrySelected={countryTo}
              citySelected={cityTo}
              companyName={recipientName}
              phoneNumber={recipientPhone}
              onChangeAddress={(item) => {
                setAddressTo(item);
                setRecipientUpdate((prev) => prev + 1);
              }}
              onRecipientPhone={setRecipientPhone}
              onCoordinates={setCoordinatesTo}
              onAddressId={setAddressIdTo}
              onChangeResipient={setRecipientName}
              onChangeCountry={handleCountryToChange}
              onChangeCity={(city) => {
                setCityTo(city);
              }}
            />
          </OrdersSectionItemInfoColumn>
        </SectionItem>

        <AviationOrderDetails {...props} errors={errors} />
        <UnifiedCarrierSelection
          {...props}
          errors={errors}
          showDriverAssignment={false}
          showCopyCount={false}
          insurance={false}
        />

        <SectionItem isShadow isPSmall>
          <OrdersSectionItemCreate
            onSubmit={submitFormData}
            isLoading={createLoading}
            submitText={isEdit ? t("common.save") : undefined}
            isHidden={true}
          />
        </SectionItem>
      </OrdersContentColumn>

      <OrdersMap
        isLoadingMap={isLoadingMap}
        routeData={routeData}
        routeStartCity={routeStartCity}
        airportFrom={airportFrom}
        airportTo={airportTo}
        addressIdFrom={addressIdFrom}
        addressIdTo={addressIdTo}
        coordinatesFrom={coordinatesFrom}
        coordinatesTo={coordinatesTo}
        points={points}
        setRouteDistance={setRouteDistance}
        setRouteDuration={setRouteDuration}
      />

      {isDisplayModal && <AccessDeniedModal onClose={() => changeDisplayModal(false)} />}
    </div>
  );
};

export default OrdersCreateAviationView;
